import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { RequireRole } from './auth/RequireRole';
import { AppShell } from './components/layout/AppShell';
import { LoginPage } from './modules/auth/LoginPage';
import { DashboardPage } from './modules/dashboard/DashboardPage';
import { NotFoundPage } from './modules/not-found/NotFoundPage';
import { ComingSoonPage } from './modules/placeholders/ComingSoonPage';
import { ComparePage } from './modules/compare/ComparePage';
import { ConditionsPage } from './modules/conditions/ConditionsPage';
import { ImportPage } from './modules/import/ImportPage';
import { ReportBuilderPage } from './modules/reports/ReportBuilderPage';
import { ReportsListPage } from './modules/reports/ReportsListPage';
import { ReportViewPage } from './modules/reports/ReportViewPage';
import { RunDetailPage } from './modules/runs/detail/RunDetailPage';
import { RunsListPage } from './modules/runs/RunsListPage';
import { NewRunWizardPage } from './modules/runs/wizard/NewRunWizardPage';
import { VehicleDetailPage } from './modules/vehicles/detail/VehicleDetailPage';
import { VehiclesListPage } from './modules/vehicles/VehiclesListPage';

export const AppRouter = () => (
  <Routes>
    <Route
      path="/login"
      element={<LoginPage />}
    />

    <Route element={<ProtectedRoute />}>
      <Route element={<AppShell />}>
        <Route
          index
          element={
            <Navigate
              to="/dashboard"
              replace
            />
          }
        />
        <Route
          path="/dashboard"
          element={<DashboardPage />}
        />
        <Route
          path="/vehicles"
          element={<VehiclesListPage />}
        />
        <Route
          path="/vehicles/:id"
          element={<VehicleDetailPage />}
        />
        <Route
          path="/conditions"
          element={<ConditionsPage />}
        />
        <Route
          path="/runs"
          element={<RunsListPage />}
        />
        {/* Declared before `/runs/:id` so the wizard's static path wins over the param route. */}
        <Route
          path="/runs/new"
          element={<NewRunWizardPage />}
        />
        <Route
          path="/runs/:id"
          element={<RunDetailPage />}
        />
        <Route
          path="/import"
          element={<ImportPage />}
        />
        <Route
          path="/compare"
          element={<ComparePage />}
        />
        <Route
          path="/reports"
          element={<ReportsListPage />}
        />
        {/* Declared before `/reports/:id` so the builder's static path wins over the param route. */}
        <Route
          path="/reports/new"
          element={<ReportBuilderPage />}
        />
        <Route
          path="/settings/users"
          element={
            <RequireRole roles={['MANAGER']}>
              <ComingSoonPage
                titleKey="nav.users"
                descriptionKey="placeholder.users"
                phase={1}
              />
            </RequireRole>
          }
        />
      </Route>

      {/*
        The saved report renders outside the AppShell: it is a full-width print document with its own slim
        action bar, and the print dialog has to see the page and nothing else (plan §8). Still protected —
        a report is internal.
      */}
      <Route
        path="/reports/:id"
        element={<ReportViewPage />}
      />
    </Route>

    <Route
      path="*"
      element={<NotFoundPage />}
    />
  </Routes>
);
